import { useMutation } from '@tanstack/vue-query'
import { followUser } from '~~/src/api/users'

export function useFollowUserMutation() {
  const { firebaseUser } = useFirebaseAuth()
  const toast = useToast()
  return useMutation<
    Awaited<ReturnType<typeof followUser>>,
    Error,
    string
  >({
    mutationFn: async (userId: string) => {
      if (!firebaseUser.value)
        throw new Error('You must be logged in to follow a user')

      if (firebaseUser.value.uid === userId)
        throw new Error('You cannot follow yourself')

      return await followUser(userId)
    },
    onSuccess: () => {
      toast.info('User followed')
    },
    onError: (err) => {
      toast.error(err.message)
    },
  })
}
